module.exports = __webpack_public_path__ + "static/img/s_1.de6e0a4e.png";